<template>
  <b-row>
    <Sidebar/>
    <b-col md="10" offset-md="2">
      <div
          class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Nuevo usuario</h1>
        <div class="btn-toolbar mb-2 mb-md-0">
          <div class="btn-group mr-2">
            <router-link class="btn btn-outline-secondary" to="/usuarios">{{ cancel.value }}</router-link>
          </div>
        </div>
      </div>

      <b-form v-on:submit.prevent="onSubmit">
        <b-form-row>
          <b-col md="6">
            <b-form-group id="firstName" label="Nombre:" label-for="firstNameInput" description="">
              <b-form-input v-model="user.first_name" id="firstNameInput" type="text"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="lastName" label="Apellidos:" label-for="lastNameInput" description="">
              <b-form-input v-model="user.last_name" id="lastNameInput" type="text"
                            required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="loginName" label="Usuario:" label-for="loginNameInput" description="">
              <b-form-input v-model="user.username" id="loginNameInput" type="text"
                            required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="email" label="E-mail:" label-for="emailInput" description="">
              <b-form-input v-model="user.email" id="emailInput" type="email" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="loginRut" label="RUT:" label-for="rutNameInput" description="">
              <b-form-input v-model="user.rut" v-mask="'99.999.999-S'" id="rutNameInput" type="text"
                            required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">

          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col md="6">
            <b-form-group id="password" label="Contraseña:" label-for="passwordInput"
                          description="Dejar en blanco para mantener contraseña actual.">
              <b-form-input v-model="user.password" id="passwordInput" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="passwordConfirm" label="Confirmar contraseña:"
                          label-for="passwordConfirmInput"
                          description="Confirmar contraseña para evitar cambios indeseados.">
              <b-form-input v-model="user.password_confirm" id="passwordConfirmInput"
                            type="text"></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-button type="submit" variant="primary" v-bind:disabled="submit.disabled">{{ submit.value }}</b-button>&nbsp;
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import {mapGetters} from 'vuex'
import AwesomeMask from 'awesome-mask'

export default {
  name: "UsersAdd",
  directives: {
    'mask': AwesomeMask
  },
  data() {
    return {
      isLoading: true,
      user: {
        'password': '',
        'password_confirm': '',
      },
      cancel: {
        value: "Cancelar creación"
      },
      submit: {
        disabled: false,
        value: "Crear"
      }
    }
  },
  methods: {
    onSubmit() {

      this.submit.disabled = true;
      this.submit.value = "Creando...";

      this.$store.dispatch('users/createSingleUser', this.user).then(() => {
        this.submit.value = "Usuario creado";
        this.cancel.value = "Regresar";
        this.$router.push("/usuarios");
      });
    },
  },
  mounted() {

    const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const passwordLength = 8;
    let password = "";

    this.$nextTick(function () {

      for (var i = 0; i <= passwordLength; i++) {
        var randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber + 1);
      }

      this.user.password = password;
      this.user.password_confirm = password;
    });

  }
}
</script>